<div class="card">
	<div class="card-header border-0 pt-6">
		<div class="card-title">
			<div class="d-flex align-items-center position-relative my-1">
				<i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
					<span class="path1"></span>
					<span class="path2"></span>
				</i>
				<input type="text" data-table-filter="search" class="form-control form-control-sm w-250px ps-12" placeholder="Search" />
			</div>
		</div>
		<div class="card-toolbar">
			<div class="d-flex justify-content-end" data-table-toolbar="base">
				<button type="button" class="btn btn-sm btn-dark me-3 text-nowrap" data-bs-toggle="modal" data-bs-target="#kt_export_modal">
					<i class="ki-duotone ki-exit-up fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
					<span>Export</span>
				</button>
				<div class="w-100">
					<select class="form-select form-select-sm" data-hide-search="true" data-placeholder="Status" data-table-filter="status">
						<option value="all" selected>All</option>
						<option value="New">New</option>
						<option value="Permitted">Permitted</option>
						<option value="Blocked">Blocked</option>
					</select>
				</div>
			</div>
			<div class="d-flex justify-content-end align-items-center d-none" data-table-toolbar="selected">
				<div class="fw-bold me-5">
					<span class="me-2" data-table-select="selected_count"></span>Selected
				</div>
				<button type="button" class="btn btn-sm btn-dark" data-table-select="delete_selected">Delete Selected</button>
			</div>
		</div>
	</div>
	<div class="card-body pt-0">
		<table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden" id="kt_table_client_export_list">
			<thead>
				<tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
					<th class="text-nowrap">
						<div class="form-check form-check-sm form-check-custom form-check-solid me-3">
							<input type="checkbox" class="form-check-input" data-kt-check="true" data-kt-check-target="#kt_table_client_export_list .invoice-number-check" value="1" />
						</div>
					</th>
					<th class="text-nowrap">Member</th>
					<th class="text-nowrap">Name</th>
					<th class="text-nowrap">Company</th>
					<th class="text-nowrap">Registration Date</th>
					<th class="text-nowrap">Email</th>
					<th class="text-nowrap">Country</th>
					<th class="text-nowrap">Status</th>
					<th class="text-nowrap">Actions</th>
				</tr>
			</thead>
			<tbody class="text-gray-600 fw-semibold">
				<tr *ngFor="let rows of fakeRows">
					<td class="text-nowrap">
						<div class="form-check form-check-sm form-check-custom form-check-solid">
							<input type="checkbox" class="form-check-input invoice-number-check" value="1" />
						</div>
					</td>
					<td class="text-nowrap">0778179225@econetmail.com</td>
					<td class="text-nowrap">Mr. Kasvosve, Tafadzwa</td>
					<td class="text-nowrap">Kasvosve, Tafadzwa</td>
					<td class="text-nowrap">21 March, 2015</td>
					<td class="text-nowrap">0778179225@econetmail.com</td>
					<td class="text-nowrap">Zimbabwe</td>
					<td data-order="Permitted">
						<div class="badge badge-light-success">Permitted</div>
					</td>
					<td class="text-nowrap">
						<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
							<i class="ki-duotone ki-down fs-5 m-0"></i>
						</a>
						<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
							<div class="menu-item px-3">
								<a href="#" class="menu-link px-3">Edit</a>
							</div>
							<div class="menu-item px-3">
								<a href="#" data-table-filter="delete_row" class="menu-link px-3">Delete</a>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>